import { gql } from "@apollo/client";

export const CreateContactPerson = gql`
    mutation CreateContactPerson($clientId: ID!, $input: ContactPersonCreateAttributesInput!) {
        createContactPerson(clientId: $clientId, input: $input) {
            id
            name
        }
    }
`;
